<hg-dropdown *ngIf="languageList.length > 1"
	[labelProp]="'name'"
	[list]="languageList"
	[listSelection]="selectedLanguage"
	(listSelectionChange)="languageChange($event)">
</hg-dropdown>